import { FAN_TAKEOVER_FLOOR_SIZES } from "./consts";

export function isFanTakeoverHeight(adHeight: number) {
  return (
    adHeight === FAN_TAKEOVER_FLOOR_SIZES.MOBILE_SUCCESS[1] ||
    adHeight === FAN_TAKEOVER_FLOOR_SIZES.DESKTOP_SUCCESS[1]
  );
}
